module.exports = __webpack_public_path__ + "img/construction.008a239a.svg";